import * as Actions from '../actions/types'

const initialState = {
    isAuth: false,
    username: "",
    role:"",
    clientId:0
}

export default function user(state = initialState, { type, payload }){
    switch (type) {
        case Actions.USER_LOG_IN: 
        case Actions.FILL_AUTH:
          return { isAuth: true, username: payload.username, role: payload.role }
        case Actions.USER_LOG_OUT:
          return { ...initialState }
        case Actions.SET_CLIENT_ID:
          return {
              ...state,
              clientId: payload.id
          }
        default:
          return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/user.js